/**
 * Which edges of a horizontal scroller still hide content, so the UI can fade
 * those edges as a cue that there is more to scroll to (ZW-276: the narrow
 * Project settings tab row).
 */
export type ScrollCue = "none" | "start" | "end" | "both";

export type HorizontalScrollMetrics = {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
};

/** Sub-pixel slack: zoomed layouts rarely land exactly on the last pixel. */
const EDGE_SLACK_PX = 1;

export function scrollCueFor(metrics: HorizontalScrollMetrics): ScrollCue {
  const hiddenStart = metrics.scrollLeft > EDGE_SLACK_PX;
  const hiddenEnd =
    metrics.scrollLeft + metrics.clientWidth <
    metrics.scrollWidth - EDGE_SLACK_PX;
  if (hiddenStart && hiddenEnd) return "both";
  if (hiddenStart) return "start";
  if (hiddenEnd) return "end";
  return "none";
}
